import React from "react";
import { Link } from "react-router-dom";

import styles from "./FooterContent.module.css";

const FooterContent = () => {
  return (
    <div className={styles.footerContent}>
      <nav className={styles.footerColumn} aria-label="Footer navigation">
        <h2>Explore</h2>
        <Link to="/home">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/info">Information</Link>
        <Link to="/gallery">Gallery</Link>
      </nav>

      <div className={styles.footerColumn}>
        <h2>Get in touch</h2>
        <p>Cleo Childminding</p>
        <p>Dawson Place, Bo'ness</p>
        <Link className={styles.contactLink} to="/contact">
          Contact us
        </Link>
      </div>
    </div>
  );
};

export default FooterContent;
